import React from 'react';
import { brandPropTypes } from './BrandPropTypes';
import Icon from '@Theme/natucare/components/Icon/Icon';
import Heading from '@Theme/natucare/modules/Footer/components/Heading/Heading';
import * as styles from './Brand.module.scss';
const Brand = ({
  address,
  contact,
  socials
}) => {
  var _contact$link;
  if (!address) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(Icon, {
    classname: styles.rootLogo,
    name: "natucareRegistered"
  }), address && /*#__PURE__*/React.createElement("address", {
    className: styles.rootAddress,
    dangerouslySetInnerHTML: {
      __html: address
    }
  }), contact && /*#__PURE__*/React.createElement("div", {
    className: styles.rootContact
  }, /*#__PURE__*/React.createElement(Heading, {
    heading: contact.heading
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.rootContactLinks
  }, /*#__PURE__*/React.createElement("a", {
    href: `mailto:${contact.email}`,
    className: styles.rootContactLink
  }, contact.email), /*#__PURE__*/React.createElement("p", {
    className: styles.rootContactTel
  }, /*#__PURE__*/React.createElement("a", {
    href: `tel:${contact.tel}`,
    className: styles.rootContactLink
  }, contact.tel), /*#__PURE__*/React.createElement("span", null, contact.operatingHours)), ((_contact$link = contact.link) === null || _contact$link === void 0 ? void 0 : _contact$link.href) && /*#__PURE__*/React.createElement("a", {
    className: styles.rootContactLink,
    href: contact.link.href
  }, contact.link.label))), socials && /*#__PURE__*/React.createElement("div", {
    className: styles.rootSocials
  }, /*#__PURE__*/React.createElement(Heading, {
    heading: socials.heading
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.rootSocialsIcons
  }, socials.items.map(({
    icon,
    href,
    title
  }, index) => /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: href,
    className: styles.rootSocialsLink,
    title: title,
    key: index
  }, /*#__PURE__*/React.createElement(Icon, {
    classname: styles.rootSocialsIcon,
    name: icon
  }))))));
};
export default Brand;